import classNames from 'classnames';


function generateColor(name) {
    return '#' + Math.floor(Math.random()*16777215).toString(16);
}


function isDarkColor(color) {
    if(color.charAt(0) !== '#' || color.length !== 7) return false;
    const r = parseInt(color.slice(1, 3), 16);
    const g = parseInt(color.slice(3, 5), 16);
    const b = parseInt(color.slice(5, 7), 16);
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    return brightness < 200;
}   


let cachedColors = {}; // cache colors

function Avatar(props) {
    let { name, initials, color, className, style, id, onClick } = props;
    if(!initials) initials = String(name).split(' ').map(n => n[0]).join('');
    initials = initials.toUpperCase();
    if(initials.length > 2) initials = initials.slice(0, 2);

    if(cachedColors[name]) color = cachedColors[name];
    if(!color) color = cachedColors[name] = generateColor(name || initials);
    style = style ? {...style, backgroundColor: color} : {backgroundColor: color};

    // return;
    const css = classNames("lds-avatar", className, isDarkColor(color) && 'is-text-white');
    return (
        <i className={css} style={style} id={id} onClick={onClick}>{initials}</i>
    );
}

export default Avatar;